import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomeScreen from "./Pages/HomeScreen";
import SingleMagazine from "./Pages/SingleMagazine";

function App() {
  return (
    <Router>
      <div className="main-outer-container">
        <Routes>
          <Route path="/magazine/:id" element={<SingleMagazine />}/>  
          <Route path="/" element={<HomeScreen />}/>       
        </Routes>
      </div>
    </Router>
  );
}

export default App;
